export default __webpack_public_path__ + "static/media/dweapons.a7f82993.png";